import React, { Component } from "react";
import ImageOrInitial from "../components/ImageOrInitial";

class UserDetails extends Component {

  constructor(props) {
    super(props);
    this.state = {
      addBinderActive: false,
    };
  }

  showAddBinder = () => {
    this.setState({ addBinderActive: !this.state.addBinderActive });
    /*
    onClick={this.showAddBinder}
    <div id="addBinder" className={this.state.addBinderActive ? "active" : null} >

        </div>
        */
  };

  render() {
    return (
      <div className="dcHeaderContainer">
        {this.props.showHero &&
        <ImageOrInitial image={this.props.img} name={this.props.title} className="dcHeaderImage"/>
        }
        <h1 className="dcHeader">{this.props.title}</h1>
      </div>
    );
  }
}
 
export default UserDetails;